import { useCallback, useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import { isIOS } from 'react-device-detect';
import moment from 'moment';

import Jwt from "jwt-decode";

import { useGbAppLogin, useRequest } from ".";
import { PROP, TYPE, URL } from "../constant";
import { useUserInfo, useLearningHistory, useGmAppLogin, useStarShop } from './'
import { diagnosisProposalSelAPI } from "../api/diagnosisAPI";
import { cpLoginAPI, gmLoginAPI, mbrspLoginAPI, membersLearnersAPI } from "../api/entryExternal";
import { useDispatch } from "react-redux";
import { mathpidLogAPICall, setActor } from "../redux/logData";
import { localAPI } from "../api/commonAPI";
import { getAppId, getUserAgent, setIOSAppId } from "../utils/utilityEtc";
import { appForegroundEvent } from "../utils/appEventFunc";

let entryType = '';
export default function usePadLogin() {
  const history = useHistory();
  const logDispatch = useDispatch();
  const [initialState, setInitial] = useState(false);

  const { setInfo, info } = useUserInfo();
  const { starAuthAPICall } = useStarShop();
  const { setLearningHistoryInfo } = useLearningHistory();

  const [appAutoLogin] = useGmAppLogin();
  const { guestLogin } = useGbAppLogin();

  // 스마트올 패드로그인 API hook
  const [smartAllLoginAPI, smartLoginData] = useRequest((data) =>
    mbrspLoginAPI(data), true
  );
  // GM 패드로그인 API hook
  const [gmLoginAPICall, gmLoginData] = useRequest((data) =>
    gmLoginAPI(data), true
  );
  // GM CP 로그인
  const [cpLoginAPICall, cpLoginData] = useRequest((data) => 
    cpLoginAPI(data), true
  )

  const [
    getLearningInfo,
    learningInfoData,
    learningInfoDataError,
  ] = useRequest((parentId, learnerId) =>
    membersLearnersAPI(parentId, learnerId), true
  );
  
  const [diagnosisProposalSelCall, diagnosisInfo] = useRequest((learnerId) =>
    diagnosisProposalSelAPI(learnerId)
  );

  // 글로벌 패드 로그인(임시)
  const globalLogin = useCallback(async (data) => {
    entryType = 'GLOBAL01';
    if (!data) return;
    await localAPI();

    smartAllLoginAPI({
      // chnCd: data.chnCd,
      // entryType: data.entryType,
      entryType: 'WJTB',
      chnCd: 'WJTB',
      cntrtNo: data.contract,
      childMemberCode: data.cMember,
      parentMemberCode: data.pMember,
    });
  })


  // 스마트올 패드 로그인 함수
  const smartAllLogin = useCallback(async (data) => {
    entryType = 'WJTB';
    if (!data) return;
    await localAPI();
    
    smartAllLoginAPI({
      chnCd: data.chnCd,
      entryType: data.entryType,
      cntrtNo: data.contract,
      childMemberCode: data.cMember,
      parentMemberCode: data.pMember,
    });

    if (data?.url) {
      const d = data.url.split("/");
      let p = null;

      switch (d[0]) {
        case "topicLearning":
          p = `/${d[0]}/${d[1]}`;
          break;
        case "courseLearning":
          p = `/${data.url}`;
          break;
      }
      history.push(p);
    }

  }, []);

  // GM 패드 로그인 함수
  const gmLogin = useCallback(async (data) => {
    entryType = 'GM';
    if (!data) return;
    await localAPI();
    gmLoginAPICall({
      "chnCd": data.chnCd,
      "parentCstmrNo": data.pMember,
      "childCstmrNo": data.cMember,
      "cntrtNo": data.cntrtNo
    });
    // starAuthAPI("M100005625");
    starAuthAPICall(data.cntrtNo);
  }, []);


  // GM APP 이메일로그인 진입
  const gmAPPLogin = useCallback(async (data) => {
    entryType = 'GM_APP';
    await localAPI();
    const appId = getAppId();
    
    if (isIOS && process.env.REACT_APP_ENV !== 'local' && !appId) {
      window.addEventListener('webkitCallbackGetAppId', async (e) => {
        await localStorage.setItem("appId", e?.detail.appId);
      });
      await setIOSAppId();
    } 
    
    const isAutoLoginChk = localStorage.getItem('mathpidLoginChk');
    const token = localStorage.getItem('access.token');
    
    if (token && isAutoLoginChk === 'Y') {
      await appAutoLogin();
    } else {
      history.push(URL.ACCOUNT.LOGIN);
    }

    // history.push(URL.ACCOUNT.GM_MEMBER_AUTH);
    setInitial(true);
  }, []);

  // GM CP 로그인
  const cpLogin = useCallback(async(data) => {
    entryType = 'CP';
    if (!data) return;
    await localAPI();

    cpLoginAPICall({
      chnCd: data.chnCd,
      parentCstmrNo: data.pMember,
      childCstmrNo: data.cMember,
      cntrtNo: data.cntrtNo,
      childNm: data.childNm,
      childYr: moment(data.childYr).format('YYYY'),
    });
    starAuthAPICall(data.cntrtNo);
  })

  // GB APP 이메일로그인 
  const gbAPPLogin = useCallback(async (data) => {
    entryType = TYPE.ENTRY_TYPE.GLOBAL01;
    
    /**
     * 토큰이 존재하는 경우와 없는 경우
     * 기존 로그인 방식에서는 토큰 기준에 따라서 자동로그인 및 로그인 페이지로 분기하는 로직에서
     * 게스트 로그인은 현재 토큰에 상관 없이 무조건 guestLogin API를 호출 후 response 결과에 따라서 분기
     * 추후 온보딩(introduction) 페이지 전환에 대해 논의 후 수정
     */

    const appId = getAppId();

    if (isIOS && process.env.REACT_APP_ENV !== 'local' && !appId) {
      window.addEventListener('webkitCallbackGetAppId', async (e) => {
        await localStorage.setItem("appId", e?.detail.appId);
        await guestLogin();
      });
      await setIOSAppId();
    } else {
      await guestLogin();
    }
    setInitial(true);
  }, [info])

  const learningInfo = useCallback(({ token, mbrId, locale, email }) => {
    
    // 로컬스토리지 데이터 set(추후 삭제 예정)
    let loginToken = Jwt(token);
    localStorage.setItem("access.token", token);
    // localStorage.setItem("user.id", loginToken.mbr);
    localStorage.setItem("locale", locale);
    localStorage.setItem("learner.id", mbrId);
    // loggerManager.setUser({ id: loginToken.mbr, name: mbrId });

    setInfo({
      userId: loginToken.mbr,
      userEmail: email,
      locale: locale,
      learnerId: mbrId,
    });

    // 회원정보 조회
    getLearningInfo(loginToken?.mbr, mbrId);
  }, [])

  // 스마트올 로그인 API 완료 후
  useEffect(() => {
    if (!smartLoginData) return;

    learningInfo({
      token: smartLoginData.accessToken,
      mbrId: smartLoginData.lrnMbrId,
      locale: 'KO'
    });

  }, [smartLoginData]);

  /**
   * 교문 패드 로그인 성공 후 (테스트용)
   */
  useEffect(() => {
    if (!gmLoginData) return;
    
    learningInfo({
      token: gmLoginData.accessToken,
      mbrId: gmLoginData.lrnMbrId,
      locale: 'KO'
    });

  }, [gmLoginData]);

  /**
  * 교문 CP 로그인 성공 후 (테스트용)
  */
  useEffect(() => {
    if (!cpLoginData) return;

    learningInfo({
      token: cpLoginData.accessToken,
      mbrId: cpLoginData.lrnMbrId,
      locale: 'KO'
    });

  }, [cpLoginData]);

  // 학습 회원 조회 
  useEffect(() => {
    if (learningInfoData) {
      const { brthmt, sxdnCd, mbrNm, mbrId, tutoYn, emailCertYn } = learningInfoData;
      const iIidx = localStorage.getItem('iIidx');
      setInfo({
        // learnerBirth: brthmt,
        learnerBirth: brthmt,
        learnerSex: sxdnCd,
        learnerName: mbrNm,
        className: '',
        iconImage: PROP.SIDE_ICON[typeof !isNaN(Number("1")) ? Number(iIidx) : 0],
        emailCertYn
      })

      logDispatch(setActor({
        account: {
          homePage: entryType,
          name: mbrId
        },
        name: info?.learnerCode ? info.learnerCode : '',
        objectType: "Agent"
      }))

      setTimeout(() => {
        // 앱 최초 진입시 호출
        logDispatch(mathpidLogAPICall({
          verbId: 'focused',
          objectId: 'application',
          idName: getUserAgent('packageName'),
          idValue: getUserAgent('VERSION_NAME')
        }));
      }, 0);
      
      setLearningHistoryInfo({ isTutorial: tutoYn });
      setInitial(true);
      
      diagnosisProposalSelCall(mbrId);

      logDispatch(mathpidLogAPICall({
        verbId: 'initialized',
        objectId: 'application',
        idName: getUserAgent('packageName'),
        idValue: getUserAgent('VERSION_NAME')
      }));
      appForegroundEvent()
    }
   }, [learningInfoData, learningInfoDataError, entryType]);
  
  useEffect(() => {
    if (!diagnosisInfo) return;

    const { dgnsRsltCnfmYn, dgnsYn, memberYn } = diagnosisInfo;
    setInfo({
      isMember: memberYn,
    });

    setLearningHistoryInfo({
      isCompleteAIDiagnosis: dgnsYn,
      isCheckAIDiagnosisResult: dgnsRsltCnfmYn,
    })

  }, [diagnosisInfo])

  return {
    globalLogin,
    smartLoginData,
    smartAllLogin,
    gmLoginData,
    gmLogin,
    cpLogin,
    gmAPPLogin,
    gbAPPLogin,
    learningInfo,
    initialState,
    setInitial,
  }
}